<template>
  <div>
    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import axios from "axios";

export default {
  name: "GraficaVueltasMundo",
  components: {
    highcharts: Chart,
  },

  data() {
    return {
      chartOptions: {
        chart: {
          type: "waterfall",
        },
        xAxis: {
          categories: [],
          title: {
            text: "Meses",
          },
        },

        yAxis: {
          title: {
            text: "Cantidad Vueltas al Mundo",
          },
        },

        exporting: {
          enabled: true,
        },
        title: {
          text: "",
          align: "center",
        },
        subtitle: {
          text: "VUELTAS AL MUNDO 2021",
          align: "center",
        },

        series: [
          {
            data: [{}],
            marker: {
              lineWidth: 3,
              fillColor: "white",
            },
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, "#ff1c79"],
                [1, "#001871"],
              ],
            },
          },
        ],

        credits: {
          enabled: false,
        },
      },
      respuesta: [],
    };
  },

  methods: {
    async getGrafica() {
      let me = this;
      await axios
        .get("/api/hidrocarburos/dashboard/getKilometrosRecorridos", {
          params: this.$parent.filter,
        })
        .then(async (response) => {
          me.respuesta = response.data;
          await me.graficaVueltasMundo(me.respuesta);
        });
    },

    async graficaVueltasMundo(resp) {
      let meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      let dias = [
        "31",
        "28",
        "31",
        "30",
        "31",
        "30",
        "31",
        "31",
        "30",
        "31",
        "30",
        "31",
      ];

      let vueltasMundo = [];
      let vm = parseFloat(40075);
      let mes = [];

      this.chartOptions.series[0].data = [{}];

      for (let i = 0; i < resp.length; i++) {
        if (resp[i].mes != 0 && resp[i].mes != null) {
          await mes.push(meses[resp[i].mes - 1]);
          await vueltasMundo.push(parseFloat(resp[i].sumaKm) / vm);
        }
      }

      this.chartOptions.xAxis.categories = mes;

      for (let i = 0; i < mes.length; i++) {
        let objGraf = {
          y: vueltasMundo[i],
        };

        this.chartOptions.series[0].data[i] = objGraf;
        this.chartOptions.series[0].name = "N° Vueltas al Mundo";
      }
    },
  },

  mounted() {
    this.getGrafica();
  },
};
</script>
